export const DATA_STORE_API_KEY = 'eventsApi';
export const DATA_TABLE_EVENTS = 'Events';
export const DATA_TABLE_TIME_SERIES = 'TimeSeries';
export const DATA_EXECUTE_API = '/devices/execute';
export const DATA_POLLING_INTERVAL = 30000;
